import { removeHyphenAndCapitalize } from '@/core/utils/dom/string'

type BreadcrumbItem = { label: string; href?: string }

export function createBreadcrumbItems(url: string): BreadcrumbItem[] {
  const pathWithoutQuery = url.split('?')[0]
  const segments = pathWithoutQuery.split('/').filter((segment) => segment !== '')

  const breadcrumbItems = segments.map((segment, index) => {
    const generateHref = () => `/${segments.slice(0, index + 1).join('/')}/`
    const isLastSegment = index < segments.length - 1

    const formattedSegment = removeHyphenAndCapitalize(segment)
    const item: BreadcrumbItem = { label: formattedSegment }
    if (isLastSegment) {
      item.href = generateHref()
    }

    return item
  })

  return breadcrumbItems
}
